const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'powerOnCamera',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a View camera!',
    haloDeviceResource: require('@/assets/device-models/SPRCAM/view_halo.png'),
    resource: require('@/assets/device-models/SPRCAM/sercomm-view-camera.png'),
    resourceType: 'image',
    secondaryText: 'Let\'s get started with pairing your new camera.',
    continueButtonText: 'Start pairing',
  },
  powerOnCamera: {
    currentStep: 'powerOnCamera',
    prevStepName: 'installationIntro',
    isLastPage: false,
    resourceType: 'image',
    resource: require('@/assets/device-models/SPRCAM/sercomm-view_power-on-camera.gif'),
    primaryText: 'Power on your camera',
    secondaryText: 'After you have assembled your View, plug it in using the supplied power adapter. The light on the front of your camera will turn on when the camera is on.',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    prevStep: 'powerOnCamera',
    prevStepName: 'instructions',
    resourceType: 'image',
    resource: require('@/assets/device-models/SPRCAM/sercomm-view_pairing-mode-light.gif'),
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the camera before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Voice confirmation',
        description: 'You will hear a voice confirmation from the camera when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a long green followed by a short green.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/SPRCAM/sercomm-view_reset.png'),
    primaryText: 'Putting View into Pairing Mode',
    secondaryText: 'If the light on the top front of the camera is not blinking green in a pattern of a long green followed by a short green, it is not in pairing mode. To manually put the View into pairing mode:',
    steps: [
      {
        title: 'Press and hold',
        description: 'Press the button on the top of your camera for 15 seconds then release. Your camera will restart which can take up to 3 minutes and the light on top of the camera will turn green then red.',
        stepNumber: 1
      },
      {
        title: 'Voice confirmation',
        description: 'After the View finishes restarting, you will hear a voice confirmation indicating the device is ready to pair. The light on the top front of your camera will also turn to a blinking green pattern in the pattern described above.',
        stepNumber: 2
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
};

export default installationInstructions;
